import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {UtilityService} from '../../../services/utility-service';
import {Router} from '@angular/router';
import {Constants} from '../../../constants/ebtq-constants';
import {Title} from '@angular/platform-browser';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {
  responseDetails = null;
  errHeading!: string;
  selNumber: any[] = [];
  serNumber: any[] = [];
  userId!: string;
  errorMessage: any[] = [];
  sellerMap: any;
  title = 'Contact Info';

  displayDataFlag = false;

  confirmFlag = false;
  cancelDisplay = false;

  contactForm = new UntypedFormGroup({
    sellerNumber: new UntypedFormControl(''),
    servicerNumber: new UntypedFormControl(''),
    sellerContactName: new UntypedFormControl(''),
    sellerContactNumber: new UntypedFormControl(''),
    sellerContactFax: new UntypedFormControl(''),
    servicerContactName: new UntypedFormControl(''),
    servicerContactNumber: new UntypedFormControl(''),
    servicerContactFax: new UntypedFormControl(''),
    subServicerNumber: new UntypedFormControl(''),
    subServicerContactName: new UntypedFormControl(''),
    subServicerContactNumber: new UntypedFormControl(''),
    subServicerContactFax: new UntypedFormControl('')
  });


  userContactInfo: any = null;
  constructor(private apiService: ApiService, private router: Router, private titleService: Title,
              private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    //this.showLoader();
    this.titleService.setTitle(this.title);
    const userId = sessionStorage.getItem('userID');
    this.userId = userId ?? '';
    this.errHeading = Constants.ERROR_HEADER;
    const userContactWrapper = {
      userid: userId
    };


    sessionStorage.setItem('currentSubMenuOption', 'contact');


    if (sessionStorage.getItem('sellerList') != null) {
      this.selNumber.push(JSON.parse(sessionStorage.getItem('sellerList')!)[0]);
      this.contactForm.controls['sellerNumber'].setValue(this.selNumber[0].value);
    }

    this.apiService.getUserContactInfo(userContactWrapper).subscribe(data=>{
      this.userContactInfo = data;
      this.initializeFields(data);
      this.cdr.detectChanges();
    },
    error=>{
      console.log(error);
    });

  }


  /* to clear the form fields */
  clear()
  {
    // Resets all fields in the FormGroup including the pre-populated field values
    this.contactForm.reset();

    // Added as a precaution just in case the selNumber array is empty
    if (this.selNumber.length !== 0)
    {
      // Sets the pre-populated field value back to its default value
      this.contactForm.controls['sellerNumber'].setValue(this.selNumber[0].value);
    }
  }

  /* To initialize the values*/
  initializeFields(data: any)
  {
    if (data != null)
    {
      console.log('Cancel button will be displayed');
      this.cancelDisplay = true;
      
      if (data.selr != null)
      {
        this.contactForm.controls['sellerNumber'].setValue(data.selr.sellerNo);
        this.contactForm.controls['sellerContactName'].setValue(data.selr.sellerName);
        this.contactForm.controls['sellerContactNumber'].setValue(data.selr.sellerPhone);
        this.contactForm.controls['sellerContactFax'].setValue(data.selr.sellerFax);

      }
      if (data.srvr != null)
      {
        this.contactForm.controls['servicerNumber'].setValue(data.srvr.sellerNo);
        this.contactForm.controls['servicerContactName'].setValue(data.srvr.sellerName);
        this.contactForm.controls['servicerContactNumber'].setValue(data.srvr.sellerPhone);
        this.contactForm.controls['servicerContactFax'].setValue(data.srvr.sellerFax);

      }
      if (data.subsrvr != null)
      {
        this.contactForm.controls['subServicerNumber'].setValue(data.subsrvr.sellerNo === 0 ? '' : data.subsrvr.sellerNo );
        this.contactForm.controls['subServicerContactName'].setValue(data.subsrvr.sellerName);
        this.contactForm.controls['subServicerContactNumber'].setValue(data.subsrvr.sellerPhone);
        this.contactForm.controls['subServicerContactFax'].setValue(data.subsrvr.sellerFax);

      }

    }
  }

  //confirmation page after the save
  saveConfirm()
  {
    //this.confirmFlag= true;
    this.router.navigate(['/reverseMortgage']);
  }


  //Saving the data to the Database
  saveContact() {
    console.log('Save contact');
    const utilityService = new UtilityService();

    //Validations for seller number, servicer number, subservicer number
    if (this.validate()) {
    //Save logic

      const sellerModel = {
        userid: this.userId,
        sellerNo: this.contactForm.get('sellerNumber')!.value,
        sellerName: this.contactForm.get('sellerContactName')!.value,
        sellerPhone: this.contactForm.get('sellerContactNumber')!.value,
        sellerFax: this.contactForm.get('sellerContactFax')!.value,
        lastUpdTime: {date: utilityService.convertDateToMillisec(new Date())}
      };

      const servicerModel = {
        userid: this.userId,
        sellerNo: this.contactForm.get('servicerNumber')!.value,
        sellerName: this.contactForm.get('servicerContactName')!.value,
        sellerPhone: this.contactForm.get('servicerContactNumber')!.value,
        sellerFax: this.contactForm.get('servicerContactFax')!.value,
        lastUpdTime: {date: utilityService.convertDateToMillisec(new Date())}
      };

      let subservicerModel = null;
    
      // subServicerNumber defaults to '' (empty string sentinel) when there is no sub-servicer;
      // must check both 0 and '' to match the original loose-equality ('!= 0') behavior.
      if (this.contactForm.get('subServicerNumber')!.value !== 0 && this.contactForm.get('subServicerNumber')!.value !== '') {
        subservicerModel = {
          userid: this.userId,
          sellerNo: this.contactForm.get('subServicerNumber')!.value,
          sellerName: this.contactForm.get('subServicerContactName')!.value,
          sellerPhone: this.contactForm.get('subServicerContactNumber')!.value,
          sellerFax: this.contactForm.get('subServicerContactFax')!.value,
          lastUpdTime: { date: utilityService.convertDateToMillisec(new Date()) }
        };
      }

      let objId = null;
      if (this.userContactInfo != null) {
        objId = this.userContactInfo.objID;
      }

      const userContactModel = {
        objID: objId,
        userid: this.userId,
        selr: sellerModel,
        srvr: servicerModel,
        subsrvr: subservicerModel,
        lastUpdUserid: this.userId,
        lastUpdTime: {date: utilityService.convertDateToMillisec(new Date())}
      };


      const userContactWrapper = {
        userContactEntityValue: userContactModel,
        userid: this.userId
      };

      this.apiService.saveOrupdateContactInfo(userContactWrapper).subscribe(() => {
        this.confirmFlag = true;
        this.cdr.detectChanges();
      }, (err) => {
        if (err.error && err.error.message) {
          this.errorMessage.push(err.error.message);
        } else {
          this.errorMessage.push(err);
        }
        console.log(err);
        this.cdr.detectChanges();
      });

    }

  }


  //All Mandatory validations for the fields
  validate() {

    // ======================================================
    // Validations for Contact Form
    // ======================================================

    this.errorMessage = [];
    const sellerNumber = this.contactForm.get('sellerNumber')!.value;
    const sellerContactName = this.contactForm.get('sellerContactName')!.value;
    const sellerContactNumber = this.contactForm.get('sellerContactNumber')!.value;
    const sellerContactFax = this.contactForm.get('sellerContactFax')!.value;
    const servicerNumber = this.contactForm.get('servicerNumber')!.value;
    const servicerContactName = this.contactForm.get('servicerContactName')!.value;
    const servicerContactNumber = this.contactForm.get('servicerContactNumber')!.value;
    const servicerContactFax = this.contactForm.get('servicerContactFax')!.value;


    if (this.contactForm.get('sellerNumber')!.value === undefined || this.contactForm.get('sellerNumber')!.value == null ||
      this.contactForm.get('sellerNumber')!.value.length === 0)
    {
      this.errorMessage.push(Constants.SELLER_NUM_LENGTH);
    }
    else if (sellerNumber != null && (isNaN(Number(sellerNumber)) || sellerNumber.toString().length !== 9))
    {
      this.errorMessage.push(Constants.SELLER_NUM_LENGTH);
    }


    if (sellerContactName === undefined || sellerContactName == null ||
      sellerContactName.length === 0)
    {
      this.errorMessage.push(Constants.SELLER_NAME_REQUIRED);
    }
    else if (sellerContactName != null && !isNaN(Number(sellerContactName)))
    {
      this.errorMessage.push(Constants.SELLER_NAME_FORMAT);
    }


    if (sellerContactNumber === undefined || sellerContactNumber == null ||
      sellerContactNumber.length === 0)
    {
      this.errorMessage.push(Constants.SELLER_PHONE_REQUIRED);
    }
    else if (sellerContactNumber != null && (isNaN(Number(sellerContactNumber)) || sellerContactNumber.length !== 10))
    {
      this.errorMessage.push(Constants.SELLER_PHONE_LENGTH);
    }


    if (sellerContactFax === undefined || sellerContactFax == null ||
      sellerContactFax.length === 0)
    {
      this.errorMessage.push(Constants.SELLER_FAX_REQUIRED);
    }
    else if (sellerContactFax != null && (isNaN(Number(sellerContactFax)) || sellerContactFax.length !== 10))
    {
      this.errorMessage.push(Constants.SELLER_FAX_LENGTH);
    }



    if (servicerNumber === undefined || servicerNumber == null ||
      servicerNumber.length === 0)
    {
      this.errorMessage.push(Constants.SERVICER_NUM_REQUIRED);
    }
    else if (servicerNumber != null && (isNaN(Number(servicerNumber)) || servicerNumber.toString().length !== 9))
    {
      this.errorMessage.push(Constants.SERVICER_NUM_LENGTH);
    }


    if (servicerContactName === undefined || servicerContactName == null ||
      servicerContactName.length === 0)
    {
      this.errorMessage.push(Constants.SERVICER_NAME_REQUIRED);
    }
    else if (servicerContactName != null && !isNaN(Number(servicerContactName)))
    {
      this.errorMessage.push(Constants.SERVICER_NAME_FORMAT);
    }


    if (servicerContactNumber === undefined || servicerContactNumber == null ||
      servicerContactNumber.length === 0)
    {
      this.errorMessage.push(Constants.SERVICER_PHONE_REQUIRED);
    }
    else if (servicerContactNumber != null && (isNaN(Number(servicerContactNumber)) || servicerContactNumber.length !== 10))
    {
      this.errorMessage.push(Constants.SERVICER_PHONE_LENGTH);
    }


    if (servicerContactFax === undefined || servicerContactFax == null ||
      servicerContactFax.length === 0)
    {
      this.errorMessage.push(Constants.SSERVICER_FAX_REQUIRED);
    }
    else if (servicerContactFax != null && (isNaN(Number(servicerContactFax)) || servicerContactFax.length !== 10))
    {
      this.errorMessage.push(Constants.SERVICER_FAX_LENGTH);
    }


    if (this.errorMessage.length > 0)
    {
      return false;
    }
    return true;
  }


}
